import { Exclude, Expose, Type } from 'class-transformer';

@Exclude()
export class CompanyModel {
  @Expose()
  id?: number;

  @Expose()
  customerId?: number | null;

  @Expose()
  companyName?: string | null;

  @Expose()
  addressLine1?: string | null;

  @Expose()
  addressLine2?: string | null;

  @Expose()
  city?: string | null;

  @Expose()
  postalCode?: string | null;

  @Expose()
  state?: string | null;

  @Expose()
  country?: string | null;

  @Expose()
  type?: string | null;

  @Expose()
  abn?: string | null;

  @Expose()
  @Type(() => Date)
  subscriptionStarted?: Date | null;

  @Expose()
  @Type(() => Date)
  subscriptionEnd?: Date | null;
}

@Exclude()
export class CompanySearchModel {
  @Expose()
  id?: number;

  @Expose()
  customerId?: number | null;

  @Expose()
  companyName?: string | null;

  @Expose()
  type?: string | null;

  @Expose()
  @Type(() => Date)
  subscriptionStarted?: Date | null;

  @Expose()
  @Type(() => Date)
  subscriptionEnd?: Date | null;

  @Expose()
  flockCount?: number;

  @Expose()
  activeFlockCount?: number;

  @Expose()
  inactiveFlockCount?: number;
}

@Exclude()
export class CompanyUserModel {
  @Expose()
  id?: number;

  @Expose()
  companyId?: number;

  @Expose()
  userId?: number;

  @Expose()
  roleId?: number;

  @Expose()
  firstName?: string | null;

  @Expose()
  lastName?: string | null;

  @Expose()
  email?: string | null;

  @Expose()
  phoneNumber?: string | null;

  @Expose()
  isPrimaryContact?: boolean;
}

@Exclude()
export class SetPrimaryContactRequest {
  @Expose()
  companyUserId: number;

  @Expose()
  isPrimaryContact: boolean;
}

@Exclude()
export class AddCompanyUserRequest {
  @Expose()
  userId?: number | null;

  @Expose()
  email: string;
}

@Exclude()
export class CompanyFlockModel {
  @Expose()
  id?: number;

  @Expose()
  companyId?: number | null;

  @Expose()
  breedFlockCode?: string | null;

  @Expose()
  breedTitle?: string | null;

  @Expose()
  breederId?: number | null;

  @Expose()
  flockCode?: string | null;

  @Expose()
  breedId?: string | null;

  @Expose()
  flockVisibility?: number;

  @Expose()
  flockGrpName?: string | null;

  @Expose()
  description?: string | null;

  @Expose()
  latestDrop?: number;

  @Expose()
  group?: string | null;

  @Expose()
  userIndexCode?: string | null;

  @Expose()
  @Type(() => Date)
  renewalStart?: Date | null;

  @Expose()
  @Type(() => Date)
  renewalEnd?: Date | null;

  @Expose()
  status?: string | null;

  @Expose()
  type?: string | null;

  @Expose()
  pics?: string[] | null;
}

@Exclude()
export class CompanyOrderModel {
  @Expose()
  id?: number;

  @Expose()
  orderNumber?: string | null;

  @Expose()
  @Type(() => Date)
  orderDate?: Date | null;

  @Expose()
  statusId?: number;

  @Expose()
  statusLabel?: string | null;

  @Expose()
  paidBy?: string | null;

  @Expose()
  subTotal?: number;

  @Expose()
  gst?: number;

  @Expose()
  total?: number;

  @Expose()
  hasRefunds?: boolean;

  @Expose()
  displayTaxInvoice?: boolean;
}

@Exclude()
export class CompanyRenewalStatusModel {
  @Expose()
  renewalStatus?: CompanyRenewalStatus;
}

@Exclude()
export class CompanyDetailModel {
  @Expose()
  @Type(() => CompanyModel)
  company?: CompanyModel | null;

  @Expose()
  @Type(() => CompanyFlockModel)
  flocks: CompanyFlockModel[] = [];

  @Expose()
  @Type(() => CompanyUserModel)
  users: CompanyUserModel[] = [];

  @Expose()
  @Type(() => CompanyOrderModel)
  orders: CompanyOrderModel[] = [];

  @Expose()
  renewalStatus?: CompanyRenewalStatus;
}

export enum CompanyRenewalStatus {
  RequiresSetup = 1,
  NotRequired,
  Due,
  Overdue,
}
